import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const updatePresetQuestions = (payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_PRESET_QUESTIONS' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(`/ads/preset-questions`, payload, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_PRESET_QUESTIONS_DONE',
              payload: {
                promptId: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback();
            }
          } else {
            dispatch({
              type: 'UPDATING_PRESET_QUESTIONS_FAILED',
              payload: `Failed to update preset questions`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_PRESET_QUESTIONS_FAILED',
            payload: `Failed to update preset questions`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'UPDATING_PRESET_QUESTIONS_FAILED',
        payload: `Failed to update preset questions`,
      });
    }
  };
};

export default updatePresetQuestions;
